import classes from "./AllowCode.module.css"
import CheckBox from "../../../../UI/CheckBox"
import { PermmisionPostsTypeEnumText } from '../../../../../models/PermmisionPostsTypeEnum'
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"


const AllowCode = ({ index, allPost, setPermissinType, permissinType, setDataPost, dataPost }) => {
    const [checked, setChecked] = useState(false)

    const { texts } = useSelector(state => state.translate);

    useEffect(() => {
        if (dataPost) {
            if (permissinType == PermmisionPostsTypeEnumText.RunnerAndCode)
                setChecked(true)
            else
                setChecked(false)
        }
    }, [permissinType]);

    function handleAllowPermmissionType() {
        setPermissinType(PermmisionPostsTypeEnumText.RunnerAndCode)
        if (dataPost) {
            let newAllPosts = [...allPost]
            newAllPosts[index].shares = [...newAllPosts[index].shares]
            newAllPosts[index].shares[0] = { ...newAllPosts[index].shares[0], permissionMask: "RunnerAndCode" }
            setDataPost(newAllPosts)
        }
        setChecked(true)


    }

    function handeleNotAllowPermmissionType() {
        setPermissinType(PermmisionPostsTypeEnumText.RunnerOnly)
        if (dataPost) {
            let newAllPosts = [...allPost]
            newAllPosts[index].shares = [...newAllPosts[index].shares]
            newAllPosts[index].shares[0] = { ...newAllPosts[index].shares[0], permissionMask: "RunnerOnly" }
            setDataPost(newAllPosts)
        }

        setChecked(false)

    }
    return (
        <>
            <div className={`${classes.AllowCode}`} >
                <CheckBox
                    checkBoxColor={"gray"}
                    checked={checked}
                    onChecked={handleAllowPermmissionType}
                    onRemoveChecked={handeleNotAllowPermmissionType}>
                </CheckBox>
                <div className={classes.AllowCodeText}>  {texts.allowViewCode} </div>

            </div>
        </>
    )
}
export default AllowCode

